import type { Carer } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

export const GET_CARERS = `/api/list/carers?isDeleted=false&isHidden=false`

const useCarers = (excludeGroupUsers = false) => {
  const { isError, isLoading, data, refetch } = useQuery(
    ['carers', { excludeGroupUsers }],
    () =>
      getJSON({
        url: `${GET_CARERS}${excludeGroupUsers ? '&excludeGroupUsers=true' : ''}`
      })
  )

  return {
    isError,
    isLoading,
    carers: (data?.result || []) as Carer[],
    fetchCarers: refetch
  }
}

export default useCarers
